// Copyright (c) Docugami, Inc. All rights reserved.

import { createListenerMiddleware, addListener } from '@reduxjs/toolkit'
import type { TypedStartListening, TypedAddListener } from '@reduxjs/toolkit'

// NOTE: We avoid importing from 'store' here to prevent circular dependencies.
// The types are set to 'any' at the middleware level, but consumers get proper
// typing through the typed hooks and selectors.

export const listenerMiddleware = createListenerMiddleware()

// Using 'any' here to avoid circular dependency with store
// The actual type safety comes from the slice definitions
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AppStartListening = TypedStartListening<any, any>

export const startAppListening =
  listenerMiddleware.startListening as AppStartListening

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const addAppListener = addListener as TypedAddListener<any, any>
